import { defineMessages } from 'react-intl';

/**
 * Internationalized messages for use on project cards.
 */
export default defineMessages({
  projectTitle: {
    id: 'project.mainSection.title',
    defaultMessage: 'Generic project',
  },
  mappingDifficulty: {
    id: 'project.nav.mappingDifficulty',
    defaultMessage: 'Difficulty level',
  },
  moreFilters: {
    id: 'project.nav.moreFilters',
    defaultMessage: 'More filters',
  },
  campaign: {
    id: 'project.nav.campaign',
    defaultMessage: 'Campaign',
  },
  startDate: {
    id: 'navFilters.startDate',
    defaultMessage: 'From',
  },
  startDatePlaceholder: {
    id: 'navFilters.startDate.placeholder',
    defaultMessage: 'Click to select a start date',
  },
  endDate: {
    id: 'navFilters.endDate',
    defaultMessage: 'To',
  },
  endDatePlaceholder: {
    id: 'navFilters.endDatePlace.placeholder',
    defaultMessage: 'Click to select an end date',
  },
  showMapToggle: {
    id: 'project.nav.showMapToggle',
    defaultMessage: 'Show map',
  },
  listViewToggle: {
    id: 'project.nav.listViewToggle',
    defaultMessage: 'List view',
  },
  typesOfMapping: {
    id: 'project.navFilters.typesOfMapping',
    defaultMessage: 'Types of mapping',
  },
  projectsToMap: {
    id: 'project.navFilters.action.map',
    defaultMessage: 'Projects to map',
  },
  projectsToValidate: {
    id: 'project.navFilters.action.validate',
    defaultMessage: 'Projects to validate',
  },
  anyProject: {
    id: 'project.navFilters.action.any',
    defaultMessage: 'Any project',
  },
  exactMatch: {
    id: 'project.navFilters.typesOfMapping.exactMatch',
    defaultMessage: 'Exact match',
  },
  campaigns: {
    id: 'project.navFilters.campaigns',
    defaultMessage: 'All campaigns',
  },
  showAllXTags: {
    id: 'project.navFilters.showAllXTags',
    defaultMessage: 'Show {typeOfTag}',
  },
  searchPlaceholder: {
    id: 'project.inputs.placeholders.search',
    defaultMessage: 'Search project',
  },
  organisation: {
    id: 'project.navFilters.organisation',
    defaultMessage: 'Organization',
  },
  organisations: {
    id: 'project.navFilters.organisations',
    defaultMessage: 'All Organizations',
  },
  location: {
    id: 'project.navFilters.location',
    defaultMessage: 'Location',
  },
  locations: {
    id: 'project.navFilters.locations',
    defaultMessage: 'Locations',
  },
  errorLoadingTheXForY: {
    id: 'project.navFilters.error',
    defaultMessage: 'Error loading the {xWord} for {yWord}',
  },
  filters: {
    id: 'project.nav.filters',
    defaultMessage: 'Filters',
  },
  projects: {
    id: 'project.nav.projects',
    defaultMessage: 'Projects',
  },
  myProjects: {
    id: 'project.nav.myprojects',
    defaultMessage: 'My Projects',
  },
  manageProjects: {
    id: 'project.nav.manageProjects',
    defaultMessage: 'Manage Projects',
  },
  favorited: {
    id: 'project.nav.favorited',
    defaultMessage: 'Favorited',
  },
  contributed: {
    id: 'project.nav.contributed',
    defaultMessage: 'Contributed',
  },
  allprojects: {
    id: 'project.nav.allprojects',
    defaultMessage: 'All',
  },
  active: {
    id: 'project.nav.active',
    defaultMessage: 'Active',
  },
  managed: {
    id: 'project.nav.managed',
    defaultMessage: 'Managed by me',
  },
  created: {
    id: 'project.nav.created',
    defaultMessage: 'Created by me',
  },
  draft: {
    id: 'project.nav.draft',
    defaultMessage: 'Draft',
  },
  archived: {
    id: 'project.nav.archived',
    defaultMessage: 'Archived',
  },
  paginationCount: {
    id: 'project.pagination.count',
    defaultMessage: 'Showing {number} of {total}',
  },
  clearFilters: {
    id: 'project.nav.clearFilters',
    defaultMessage: 'Clear filters',
  },
  sortBy: {
    id: 'project.sortby',
    defaultMessage: 'Sort by',
  },
  sortByIdDesc: {
    id: 'project.sortby.id.descending',
    defaultMessage: 'New projects',
  },
  sortByIdAsc: {
    id: 'project.sortby.id.ascending',
    defaultMessage: 'Old projects',
  },
  sortByPriority: {
    id: 'project.sortby.priority',
    defaultMessage: 'Urgent projects',
  },
  sortByBeginner: {
    id: 'project.sortby.difficulty.beginner',
    defaultMessage: 'Beginner projects',
  },
  sortByAdvanced: {
    id: 'project.sortby.difficulty.advanced',
    defaultMessage: 'Advanced projects',
  },
  sortByMoreActive: {
    id: 'project.sortby.more_active',
    defaultMessage: 'Active projects',
  },
  apply: {
    id: 'project.nav.apply',
    defaultMessage: 'Apply',
  },
  clear: {
    id: 'project.nav.clear',
    defaultMessage: 'Clear',
  },
  retry: {
    id: 'project.results.retry',
    defaultMessage: 'Retry',
  },
});
